<template>
    <MainContainer :hideSidebar="true">
        <div class="home w-50 mx-auto text-center">
            <h2>Herzlich Willkommen in der Verwaltung des Musikvereins</h2>
            <p>Zum Fortfahren wählen Sie bitte einen Menüpunkt aus</p>
        </div>
        <Dashboard />
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import MainContainer from "@/components/MainContainer/MainContainer";
import Dashboard from "@/components/Dashboard/Dashboard";

export default {
    name: "home",
    components: {
        MainContainer,
        Dashboard
    }
};
</script>
